import {Injectable} from '@angular/core';
import {Logger} from './dip-registration-logger.service';
import {getDiprsContext} from '../utilities/dip-registration-utility';

const noop = (): any => undefined;

@Injectable()
export class DipRegistrationConsoleLoggerService implements Logger {

  constructor() {
  }

  get info() {
    return window.console ? window.console.info.bind(console) : noop;
  }

  get debug() {
    return window.console && getDiprsContext().loggingEnabled ? window.console.debug.bind(console) : noop;
  }

  get warn() {
    return window.console ? window.console.warn.bind(console) : noop;
  }

  get error() {
    return window.console ? window.console.error.bind(console) : noop;
  }

}
